import { flushSync } from "react-dom";

type DocumentWithVT = Document & {
  startViewTransition?: (callback: () => void) => { finished: Promise<void> };
};

/**
 * Runs a React state update inside the View Transitions API when available.
 * No-ops to a normal update when unsupported, or when the user prefers reduced motion.
 */
export function withViewTransition(update: () => void): void {
  if (typeof document === "undefined") {
    update();
    return;
  }

  try {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      update();
      return;
    }
  } catch {
    update();
    return;
  }

  const doc = document as DocumentWithVT;
  if (typeof doc.startViewTransition !== "function") {
    update();
    return;
  }

  doc.startViewTransition(() => {
    flushSync(update);
  });
}
